import { lazy } from 'react';
import KeepAlive from 'react-activation';
import Loading from '../components/Loading';
import { Suspense } from 'react';

const App = lazy(() => import('@/layouts/App'));
const Home = lazy(() => import('@/pages/home/Home'));
const PersonalInfo = lazy(() => import('@/pages/personal-info/PersonalInfo'));
const GeneralConfigPage = lazy(
  () => import('@pages/general-config/GeneralConfigPage'),
);

const homeRoute = [
  //重定向
  //  {
  //     path:'/data',
  //     redirect:'/'
  // },
  {
    path: '/layout',
    name: 'App',
    element: <App />,
    children: [
      {
        path: 'home',
        name: '工作台',
        element: (
          <Suspense fallback={<Loading />}>
            <Home />
          </Suspense>
        ),
      },
      {
        path: 'personal-info',
        name: '个人信息',
        element: (
          <KeepAlive name="/layout/personal-info">
            <Suspense fallback={<Loading />}>
              <PersonalInfo />
            </Suspense>
          </KeepAlive>
        ),
      },
      {
        path: 'general-config',
        name: '通用配置',
        element: (
          <KeepAlive name="/layout/general-config">
            <Suspense fallback={<Loading />}>
              <GeneralConfigPage />
            </Suspense>
          </KeepAlive>
        ),
      },
    ],
  },
];
export default homeRoute;
